import terminalService from '@/api/terminal'

export default {
  /**
   * Get All Settings
   * @param {*} params Query Options
   */
  getAll(params) {
    return terminalService.Api().get('settings/all', { params })
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get general Settings
   */
  getGeneral() {
    return terminalService.Api().get('settings/general')
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  /**
   * Update the general settings
   * @param {} data
   */
  updateGeneral(data) {
    return terminalService.Api().put('settings/general', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },

  getRegister() {
    return terminalService.Api().get('settings/register')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update register settings
   * @param {} date
   */
  updateRegister(data) {
    return terminalService.Api().put('settings/register', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get device settings
   */
  getDevice() {
    return terminalService.Api().get('settings/device')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Update the device settings
   * @param {*} data
   */
  updateDevice(data) {
    return terminalService.Api().put('settings/device', data)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Get All Store media
   */
  getMedia() {
    return terminalService.Api().get('settings/media')
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  /**
   * Upload Image to media folder
   */
  async uploadMedia(image) {
    // console.log('uploadMedia', image)
    const bodyFormData = new FormData()
    const newFile = this.dataURLtoFile(image.dataUrl, image.info.name)
    bodyFormData.append('image', newFile)
    // console.log('image uploading', newFile)
    return terminalService.Api().post('settings/media', bodyFormData)
      .then(response => response.data)
      .catch((error) => { throw error })
  },
  dataURLtoFile(dataurl, filename) {
    const arr = dataurl.split(',')
    const mime = arr[0].match(/:(.*?);/)[1]
    const bstr = atob(arr[1])
    let n = bstr.length
    const u8arr = new Uint8Array(n)
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n)
    }
    return new File([u8arr], filename, { type: mime })
  },

}
